document.addEventListener('DOMContentLoaded', function() {
  const phoneNumber = '{{ settings.whatsapp_phone }}';
  const defaultMessage = encodeURIComponent('{{ settings.whatsapp_message }}');
  const whatsappButton = document.querySelector('.whatsapp-button');
  
  whatsappButton.addEventListener('click', function() {
    window.location.href = `https://api.whatsapp.com/send?phone=3107050165&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20hablar%20con%20alguien`;
  });
});
